import template from './coworking-min-lease-term.jade';
import validation from '../../../services/validation';
import './coworking-min-lease.css';

export default angular
  .module('cian.addForm.coworkingMinLeaseTerm', [])
  .directive('cianAfAboutObjectCoworkingMinLeaseTerm', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.limitMin = 0;
      this.limitMax = 1e3;

      this.validation = validation(this.form, 'bargainTerms.minLeaseTerm', {
        parse: 'Введите число',
        min: 'Срок должен быть больше 0',
        max: 'Не более 3 символов',
        required: 'Укажите минимальный срок',
      });
    },
    controllerAs: 'minLeaseTerm',
    template,
  }))
  .name;
